import PropTypes from "prop-types";
import styles from "./CategoryHeader.css";
import CategoryHeaderDescription from "./CategoryHeaderDescription";
import CategoryHeaderLinks from "./CategoryHeaderLinks";
import CategoryHeaderTitle from "./CategoryHeaderTitle";
import { CATEGORY_BANNER_ID } from "../constants";
import CategoryHeaderRibbon from "../CategoryHeaderRibbon";
import { withTranslation } from "../translation";
import shouldShowNewInTodayRibbon from "./shouldShowNewInTodayRibbon";

export const CategoryHeader = ({
  hasHeaderLinks,
  category,
  loyaltyIsEnabled,
  loyaltyIsOptedIn,
  formatTranslation
}) => (
  <section id={CATEGORY_BANNER_ID} className={styles.wrapper}>
    <div className={styles.textWrapper}>
      <CategoryHeaderTitle />
      <CategoryHeaderDescription />
      {hasHeaderLinks && <CategoryHeaderLinks />}
      {shouldShowNewInTodayRibbon({
        loyaltyIsEnabled,
        loyaltyIsOptedIn,
        categoryId: category.id
      }) && (
        <CategoryHeaderRibbon
          ribbonText={formatTranslation("ea_new_in_plp_banner")}
        />
      )}
    </div>
  </section>
);

CategoryHeader.propTypes = {
  hasHeaderLinks: PropTypes.bool.isRequired,
  loyaltyIsEnabled: PropTypes.bool,
  category: PropTypes.shape({
    id: PropTypes.number
  }).isRequired,
  loyaltyIsOptedIn: PropTypes.bool,
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(CategoryHeader);
